// extracted by mini-css-extract-plugin
export default {"snippet":"_3VYW","copyButton":"_1_MX"};